<script setup lang="ts">
import { computed } from 'vue';
import { formatPickup } from '../format';
import type { PdsOrder } from '../types';
import PaperTicket from './PaperTicket.vue';

const props = defineProps<{
  order: PdsOrder;
  store: string;
  printedAt: string;
  operator: string;
}>();

const pieces = computed(() =>
  props.order.items.reduce((sum, item) => sum + item.quantity, 0),
);
</script>

<template>
  <PaperTicket>
    <div class="text-center">
      <p class="font-bold uppercase">{{ store }}</p>
      <p class="text-[20px] leading-[1.2] font-bold uppercase">
        Bon de préparation
      </p>
      <p class="mt-[10px] text-[14px] leading-[20px] font-bold">
        #{{ order.orderNumber ?? order.number }} · {{ order.label }}
      </p>
      <p>Retrait {{ formatPickup(order.dueAt) }}</p>
    </div>
    <hr class="my-[10px] h-[3px] border-0 bg-[#1a1a1a]" />

    <template v-if="order.customerNote">
      <p class="font-bold uppercase">Client</p>
      <p class="text-[14px] leading-[20px] font-bold">
        {{ order.customerNote }}
      </p>
      <hr class="my-[10px] h-[3px] border-0 bg-[#1a1a1a]" />
    </template>

    <div
      v-for="item in order.items"
      :key="item.id"
      class="border-b border-[#1a1a1a] py-[10px] first:pt-0"
    >
      <p class="text-[18px] leading-[1.2] font-bold uppercase">
        {{ item.quantity }} {{ item.name }}
      </p>
      <p v-if="item.option" class="pl-[10px]">{{ item.option }}</p>
    </div>

    <hr class="my-[10px] h-[3px] border-0 bg-[#1a1a1a]" />
    <div class="text-center">
      <p>{{ order.items.length }} produits · {{ pieces }} pièces</p>
      <p class="mt-[10px]">Imprimé à {{ printedAt }} par {{ operator }}</p>
    </div>
  </PaperTicket>
</template>
